import { Button, DataSource, HorizontalSpacer, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutQuoteStopTable extends Layout {
    buttonAddAnotherStop: Button;
    horizontalspacer1: HorizontalSpacer;
    panelStopContainer: Panel;
    sourceQuoteStop: DataSource;
    tableStop: Table;
}
